export default {
  created: function () { },
  methods: {
    DisplaySuccess(title, text) {
      this.DisplayToastr(title, text, "success");
    },
    DisplayError(title, text) {
      this.DisplayToastr(title, text, "danger");
    },
    DisplayToastr(title, text, messageType, toasterType) {
      var configObject = {
        title: title,
        autoHideDelay: 7000,
        variant: messageType,
        appendToast: true,
        toaster: toasterType,
        noAutoHide: false
      }

      if (toasterType == "") {
        configObject.toasterType = "b-toaster-top-right";
      }
      if (messageType == "danger") {
        configObject.noAutoHide = true;
      }

      this.$bvToast.toast(text, configObject);
    },
  }
}
